import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { headerBg, openPositions, subcontractingOpportunities } from 'images/careers';
import { CardsSection, SliderSection, WorkWithUs } from 'containers/careers';
import { EnergyOrangeIcon, EngineeringOrangeIcon } from 'svgs/expertise';

const Careers: NextPage = () => {
  return (
    <>
      <Header
        title="Careers"
        description="We don’t expect success, we work for it. Become a part of an amazing team!"
        image={headerBg}
      />
      <WorkWithUs
        title="Work with Us"
        text="At Utilities One, we appreciate professionalism, expertise, commitment, and initiative. We welcome new vision and passion, giving people the opportunity to express themselves in business. Supporting every member of our team takes us to the next level. Innovation isn't just about the technology, Innovation is being driven by out of the box thinkers.  A path to development is built by strengthening our existing abilities and gaining new ones.
"
      />
      <SliderSection
        sliderList={[
          { title: 'Equal Opportunity Employer' },
          { title: 'Comfortable Work Environment' },
          { title: 'Benefits' },
          { title: 'Career Growth' },
          { title: 'Friendly Teammates' },
          { title: 'Diversity and Inclusion' },
          { title: 'Play to Your Strengths' },
        ]}
      />
      <CardsSection
        listContent={[
          {
            title: 'Open positions',
            image: openPositions,
            icon: <EnergyOrangeIcon />,
            link: 'https://utilitiesone.pinpointhq.com/en',
          },
          {
            title: 'Subcontracting Opportunities',
            image: subcontractingOpportunities,
            icon: <EngineeringOrangeIcon />,
            link: '/subcontracting',
          },
        ]}
      />
    </>
  );
};

export default Careers;
